import type { FaireProductEntity } from "../../entity_types/product";

export const p_wr3v8w25tv: FaireProductEntity = {
  token: "p_wr3v8w25tv",
  type: "product",
  name: "OMG Pop Fidgety Mini's - Halloween Edition Pack",
  brandToken: "b_1785c86e",
  brandName: "Top Trenz Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/96b82df304f6d6ba5b65683c703e378e760e4a04991a9722697d3d732d89c5fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/79ee2c7ea514e7c861f6d20a78abcdd259de3e7e0802d69efaa34bd2b7aa3707.jpeg",
  ],
  priceDollars: 1.5,
  description:
    "Introducing OMG! Pop Fidgety Minis - Halloween edition! The fun pocket-size bubble-popping fidget toy you can take on the go!\n3 inches\n\nMinimum 24 pieces\n\nCopyright © 2023 Top Trenz Inc. All Rights Reserved.",
  tags: [],
  msrpDollars: 3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:39.668Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
